import { BaseApi } from './base.api';
import { handleException, handleData } from '../_services/response.handler';

/**
 * Webpack JSON의 default export 해석 차이로 import 가 undefined 가 되는 경우가 있어 require 사용.
 */
const PARENT_DEFECT_TYPES_HAL_STATIC = require('../constants/parentDefectTypesHalStatic.json');

/**
 * true이면 findByParentIsNullOrderByName 을 서버에 요청한다.
 * 기본은 정적 스냅샷(parentDefectTypesHalStatic.json)만 사용 — 마스터 변경 시 JSON 동기화 또는 이 플래그로 검증.
 */
const FETCH_PARENT_DEFECT_TYPES_FROM_API =
  process.env.VUE_APP_PARENT_DEFECT_TYPES_FETCH === 'true';

function cloneParentDefectTypesHal() {
  const raw =
    PARENT_DEFECT_TYPES_HAL_STATIC &&
    PARENT_DEFECT_TYPES_HAL_STATIC._embedded &&
    Array.isArray(PARENT_DEFECT_TYPES_HAL_STATIC._embedded.defectTypes)
      ? PARENT_DEFECT_TYPES_HAL_STATIC
      : null;
  if (!raw) {
    console.error('[DEFECT TYPE API] parentDefectTypesHalStatic.json 로드 실패');
    return { _embedded: { defectTypes: [] } };
  }
  return JSON.parse(JSON.stringify(raw));
}

//거의 고정된 값들 결함 리스트종류,메인 결함리스트  api로 처리
/**
 * 결함 타입 관련 api
 * 상세결함 타입은 메인결함 타입에 따라 달라지므로 module.defect.api에서 처리
 */
export const defectTypeApi = {
  // 결함 타입 목록 조회
  getDefectTypes: async () => {
    try {
      console.log('[DEFECT TYPE API] 모든 결함 타입 조회 시작');
      const response = await BaseApi.get('/defectTypes');
      console.log('[DEFECT TYPE API] 모든 결함 타입 조회 완료:', response);
      return handleData(response);
    } catch (error) {
      console.error('[DEFECT TYPE API] 모든 결함 타입 조회 실패:', error);
      return handleException(error);
    }
  },

  // 부모 결함 타입 조회 (parent가 null인 경우) — HAL 형태는 서버 응답과 동일
  getParentDefectTypes: async () => {
    if (!FETCH_PARENT_DEFECT_TYPES_FROM_API) {
      return cloneParentDefectTypesHal();
    }
    try {
      console.log('[DEFECT TYPE API] 부모 결함 타입 조회 시작 (network)');
      const response = await BaseApi.get('/defectTypes/search/findByParentIsNullOrderByName');
      console.log('[DEFECT TYPE API] 부모 결함 타입 조회 완료:', response);
      return handleData(response);
    } catch (error) {
      console.error('[DEFECT TYPE API] 부모 결함 타입 조회 실패 (방법 1), fallback 시도:', error);
      try {
        const response = await BaseApi.get('/defectTypes');
        const allTypes = handleData(response);
        const parentTypes = allTypes._embedded?.defectTypes?.filter(type => !type.parent) || [];
        console.log('[DEFECT TYPE API] 부모 결함 타입 조회 완료 (fallback):', parentTypes);
        return { _embedded: { defectTypes: parentTypes } };
      } catch (error2) {
        console.error('[DEFECT TYPE API] 부모 결함 타입 조회 실패 (fallback):', error2);
        return handleException(error2);
      }
    }
  }
};
